












import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import useBrandConfig from '@shared/composables/useBrandConfig';
import useResponsive from '@shared/composables/useResponsive';
import { BannerAspectRatioSize } from '@shared/types/BannerAspectRatio';
import { Image } from '@shared/types/Image';
import { UCStoryblokImage } from '@shared/ui';

export default defineComponent({
  name: 'BannerAspectRatio',
  components: {
    UCStoryblokImage,
  },
  props: {
    size: {
      type: String,
      default: 'medium',
    },
    bannerImage: {
      type: Object as PropType<Image>,
      required: true,
    },
    bannerImageMobile: {
      type: Object as PropType<Image>,
      default: null,
    },
    preload: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: String as PropType<'lazy' | 'eager'>,
      default: 'eager',
    },
  },
  setup(props) {
    const { isMobile } = useResponsive();
    const { componentConfig } = useBrandConfig();

    const { aspectRatios } = componentConfig.BannerAspectRatio;

    const hasMobileImage = computed(() => props.bannerImageMobile?.src);

    const computedImageSrc = computed(() => {
      if (isMobile.value && hasMobileImage.value) {
        return props.bannerImageMobile?.src || '';
      }
      return props.bannerImage.src;
    });

    const computedImageAlt = computed(() => {
      if (isMobile.value && hasMobileImage.value) {
        return props.bannerImageMobile?.alt || '';
      }
      return props.bannerImage.alt || '';
    });

    const containerStyle = computed(() => {
      const { mobile, desktop } = aspectRatios[props.size as BannerAspectRatioSize];

      return {
        '--ratio-mobile': mobile,
        '--ratio-desktop': desktop,
      };
    });

    return {
      computedImageSrc,
      computedImageAlt,
      containerStyle,
    };
  },
});
